import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText, CheckCircle2 } from "lucide-react";
import { submitCatalogLead, CATALOG_DOWNLOAD_URL, trackEvent, gtmPush } from "../../lib/api";

export default function CatalogDownload() {
  const [data, setData] = useState({ full_name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!data.full_name.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)) {
      toast.error("Ingresa nombre y correo válido.");
      return;
    }
    setLoading(true);
    try {
      const res = await submitCatalogLead(data);
      trackEvent("catalog_lead_submitted");
      gtmPush("catalog_download", { lead_id: res?.lead_id || res?.id });
      toast.success("Te enviaremos el catálogo por correo.");
      setDone(true);
      // Disparar descarga directa
      window.open(CATALOG_DOWNLOAD_URL, "_blank");
      setData({ full_name: "", email: "" });
      return res;
    } catch (err) {
      toast.error("No pudimos registrar tu descarga. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="catalog-section" className="bg-navy-500 text-white section-pad relative overflow-hidden">
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-accent/10 blur-3xl rounded-full pointer-events-none" />
      <div className="container-tight grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16 items-center">
        <div className="relative">
          <div className="aspect-[3/4] bg-eclipse-800 border border-white/10 relative overflow-hidden">
            <img src="/images/vt_hero_velarias_tens.jpg" alt="Catálogo Velarias Tens" className="absolute inset-0 w-full h-full object-cover opacity-60" />
            <div className="absolute inset-0 bg-gradient-to-t from-eclipse via-eclipse/40 to-transparent" />
            <div className="absolute top-6 left-6 right-6">
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent">Velarias Tens</p>
              <h3 className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tightest">
                Catálogo<br />2026
              </h3>
            </div>
            <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3 text-white/70">
              <FileText className="w-5 h-5" />
              <span className="font-mono text-xs">PDF · 2 páginas · ~120 KB</span>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-accent" />
            <span className="kicker-bright">Lead magnet</span>
          </div>
          <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            Descarga el <span className="text-accent">catálogo completo</span> de Velarias Tens.
          </h2>
          <p className="mt-6 max-w-xl text-white/75 text-base md:text-lg">
            Tipos de velaria, especificaciones técnicas, casos de éxito y más.
          </p>

          {done ? (
            <div className="mt-10 border border-accent bg-eclipse-800 p-6 md:p-8 flex items-start gap-4" data-testid="catalog-success">
              <CheckCircle2 className="w-8 h-8 text-accent flex-shrink-0" />
              <div>
                <h3 className="font-display font-black text-xl text-white">¡Descarga iniciada!</h3>
                <p className="mt-2 text-white/70 text-sm">
                  Si no se abrió automáticamente,{" "}
                  <a href={CATALOG_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="text-accent underline">haz clic aquí</a>.
                  También enviaremos el PDF a tu correo.
                </p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3" data-testid="catalog-form" noValidate>
              <input
                type="text"
                required
                placeholder="Tu nombre"
                value={data.full_name}
                onChange={(e) => setData({ ...data, full_name: e.target.value })}
                className="flex-1 bg-eclipse border border-white/15 px-5 py-4 text-white placeholder:text-white/40 focus:outline-none focus:border-accent"
                data-testid="catalog-input-name"
              />
              <input
                type="email"
                required
                placeholder="tu@correo.com"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                className="flex-1 bg-eclipse border border-white/15 px-5 py-4 text-white placeholder:text-white/40 focus:outline-none focus:border-accent"
                data-testid="catalog-input-email"
              />
              <button
                type="submit"
                disabled={loading}
                className="btn-accent whitespace-nowrap disabled:opacity-60"
                data-testid="catalog-submit"
              >
                <Download className="w-4 h-4" />
                {loading ? "Enviando…" : "Descargar gratis"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
